import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IOutputChannelModelService = ( createDecorator('outputChannelModelService'));
export { IOutputChannelModelService };
